import { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AppErrorBoundary } from '@/components/app-error-boundary';
import { ScrollToTop } from '@/components/scroll-to-top';
import { AgeGate } from '@/features/auth/AgeGate';
import { TelegramAuthCallback } from '@/features/auth/TelegramAuthCallback';
import { initializeFeatures } from '@/features/index';
import { PolicyPage, TermsPage } from '@/features/policy';
import { strings } from '@/lib/strings';

const AdminLayout = lazy(() => import('@/core/layout').then((module) => ({ default: module.AdminLayout })));
const AuthRoute = lazy(() => import('@/features/routing/AuthRoute').then((module) => ({ default: module.AuthRoute })));

initializeFeatures();

function App() {
  return (
    <BrowserRouter>
      <AppErrorBoundary>
        <ScrollToTop />
        <Suspense
          fallback={
            <div className="flex min-h-screen items-center justify-center px-6 text-muted-foreground">
              {strings.topbar.loadingSection}
            </div>
          }
        >
          <Routes>
            <Route
              path="/"
              element={
                <AgeGate>
                  <Navigate to="/catalog" replace />
                </AgeGate>
              }
            />
            <Route path="/auth" element={<AuthRoute />} />
            <Route
              path="/auth/telegram/callback"
              element={<TelegramAuthCallback />}
            />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/policy" element={<PolicyPage />} />
            <Route
              path="/*"
              element={
                <AgeGate>
                  <AdminLayout />
                </AgeGate>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </AppErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
